var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgGroup(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 30,
    viewBox: "0 0 32 30",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M15.0656 21.5938H16.9344V29.0938H15.0656V21.5938Z",
    fill: "#806A50"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    d: "M7.56561 21.5938H9.44061V23.4688H7.56561V21.5938Z",
    fill: "#806A50"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_3",
    d: "M0.305511 16.0938H11.8288L15.3315 12.5303C15.6986 12.1568 16.3012 12.1567 16.6685 12.5302L20.1731 16.0938H31.6946L28.4476 6.29883H3.55245L0.305511 16.0938Z",
    fill: "#806A50"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_4",
    d: "M24.4406 4.42375V1.84375C24.4406 1.326 24.0209 0.90625 23.5031 0.90625H19.7531C19.2354 0.90625 18.8156 1.326 18.8156 1.84375V4.42375H24.4406Z",
    fill: "#806A50"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_5",
    d: "M31.0625 27.2189H30.0312V17.9689H19.7801C19.5287 17.9689 19.2879 17.868 19.1117 17.6888L16.0002 14.5249L12.8904 17.6886C12.7142 17.8679 12.4733 17.9689 12.2219 17.9689H1.96875V27.2189H0.9375C0.41975 27.2189 0 27.6387 0 28.1564C0 28.6742 0.41975 29.0939 0.9375 29.0939H13.1906V20.6564C13.1906 20.1387 13.6104 19.7189 14.1281 19.7189H17.8719C18.3896 19.7189 18.8094 20.1387 18.8094 20.6564V29.0939H31.0625C31.5802 29.0939 32 28.6742 32 28.1564C32 27.6387 31.5802 27.2189 31.0625 27.2189ZM11.3156 24.4064C11.3156 24.9242 10.8959 25.3439 10.3781 25.3439H6.62813C6.11038 25.3439 5.69063 24.9242 5.69063 24.4064V20.6564C5.69063 20.1387 6.11038 19.7189 6.62813 19.7189H10.3781C10.8959 19.7189 11.3156 20.1387 11.3156 20.6564V24.4064ZM26.3156 24.4064C26.3156 24.9242 25.8959 25.3439 25.3781 25.3439H21.6281C21.1104 25.3439 20.6906 24.9242 20.6906 24.4064V20.6564C20.6906 20.1387 21.1104 19.7189 21.6281 19.7189H25.3781C25.8959 19.7189 26.3156 20.1387 26.3156 20.6564V24.4064Z",
    fill: "#806A50"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_6",
    d: "M22.5656 21.5938H24.4406V23.4688H22.5656V21.5938Z",
    fill: "#806A50"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGroup);
export default __webpack_public_path__ + "static/media/Group.4ff0e1b22ebc0d5f736e42e3104f1419.svg";
export { ForwardRef as ReactComponent };